"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextToolbarUI = void 0;
var react_1 = __importDefault(require("react"));
var slate_react_1 = require("slate-react");
var get_1 = __importDefault(require("lodash/get"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var Models_1 = require("@CommonFrontend/ContentTokens/Models");
var commonTypes_1 = require("@CommonFrontendBackend/StyleServiceV2/Config/BlockConfig/commonTypes");
var EventUtils_1 = require("@CommonFrontend/Utils/EventUtils");
var WidgetManager_1 = require("Project/QwilrEditor/WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var FilterButtonConfigs_1 = require("./FilterButtonConfigs");
var TextTypeMenu_1 = require("./Menus/TextTypeMenu");
var ListItemMenu_1 = require("./Menus/ListItemMenu");
var FontSize_1 = require("./Menus/FontSize");
var TextColorMenu_1 = require("./Menus/TextColorMenu");
var GetControls_1 = __importDefault(require("DreamCoat/Contextual/ContextualTextStyle/GetControls"));
var TextAlignment_1 = require("./Menus/TextAlignment");
var styles = __importStar(require("./TextToolbarUI.css"));
var TextToolbarUI = function (_a) {
    var visible = _a.visible, widgetManager = _a.widgetManager, buttonConfigs = _a.buttonConfigs, blockStore = _a.blockStore, onFocusChange = _a.onFocusChange, selectedTextWidgets = _a.selectedTextWidgets;
    var editor = (0, slate_react_1.useSlate)();
    var filteredButtonConfigs = visible ? (0, FilterButtonConfigs_1.filterButtonConfigs)(editor, buttonConfigs, blockStore.isSavedBlock) : [];
    return (react_1.default.createElement(kaleidoscope_1.Toolbar, { className: styles.wrapper, visible: visible, positionType: kaleidoscope_1.ToolbarPositionType.None },
        react_1.default.createElement("div", { className: styles.toolbarElementsFocusContainer, onFocus: function (e) { return onFocusChange(e, "toolbar", true); }, onBlur: function (e) { return onFocusChange(e, "toolbar", false); }, tabIndex: -1 },
            react_1.default.createElement(ToolbarElements, { widgetManager: widgetManager, filteredButtonConfigs: filteredButtonConfigs, blockStore: blockStore, selectedTextWidgets: selectedTextWidgets, onFocusChange: onFocusChange }))));
};
exports.TextToolbarUI = TextToolbarUI;
var ToolbarElements = function (_a) {
    var filteredButtonConfigs = _a.filteredButtonConfigs, widgetManager = _a.widgetManager, blockStore = _a.blockStore, selectedTextWidgets = _a.selectedTextWidgets, onFocusChange = _a.onFocusChange;
    var editor = (0, slate_react_1.useSlate)();
    var selectedElementTypes = calcSelectedTextElements(selectedTextWidgets.map(function (_a) {
        var element = _a.element;
        return element;
    }));
    var contextualControls = getAvailableContextualControls(selectedElementTypes, filteredButtonConfigs);
    var hasWidgetOverrides = selectedTextWidgets.some(function (_a) {
        var overrides = _a.overrides;
        return Object.keys(overrides).length > 0;
    });
    var _b = getStyleableValues("alignable", selectedTextWidgets), isAlignAllowed = _b.isAllowed, alignableValues = _b.valuesInSelection;
    function onToolbarEvent(eventData) {
        widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent("toolbar", eventData));
    }
    function onStyleChange(type, val) {
        var e_1, _a, _b;
        try {
            for (var selectedTextWidgets_1 = __values(selectedTextWidgets), selectedTextWidgets_1_1 = selectedTextWidgets_1.next(); !selectedTextWidgets_1_1.done; selectedTextWidgets_1_1 = selectedTextWidgets_1.next()) {
                var _c = selectedTextWidgets_1_1.value, element = _c.element, styleableConfig = _c.styleableConfig;
                var styleableProperty = styleableConfig.properties.find(function (s) { return s.type === type; });
                if (styleableProperty) {
                    widgetManager.updateStyle(element, (_b = {}, _b[styleableProperty.path] = val, _b));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selectedTextWidgets_1_1 && !selectedTextWidgets_1_1.done && (_a = selectedTextWidgets_1.return)) _a.call(selectedTextWidgets_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    function renderButton(buttonType) {
        var buttonConfig = filteredButtonConfigs.find(function (_a) {
            var type = _a.type;
            return type === buttonType;
        });
        if (!buttonConfig)
            return null;
        var isSelected = buttonConfig.isActive(editor, { contextualStylesShowing: false });
        return react_1.default.createElement(TopLevelButton, { buttonConfig: buttonConfig, onToolbarEvent: onToolbarEvent, isSelected: isSelected });
    }
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TextTypeMenu_1.TextTypeMenu, { filteredButtonConfigs: filteredButtonConfigs, onToolbarEvent: onToolbarEvent, onFocusChange: onFocusChange }),
        contextualControls.showTextSize && react_1.default.createElement(FontSize_1.FontSize, null),
        contextualControls.showTextColor && (react_1.default.createElement(TextColorMenu_1.TextColorMenu, { blockStore: blockStore, onChange: function (color) {
                return onToolbarEvent({
                    action: "textColorChange",
                    color: color,
                });
            }, onFocusChange: onFocusChange, selectedElementTypes: selectedElementTypes })),
        renderButton(EditorTypes_1.MarkType.Bold),
        renderButton(EditorTypes_1.MarkType.Italic),
        isAlignAllowed && (react_1.default.createElement(TextAlignment_1.TextAlignment, { valuesInSelection: alignableValues, onFocusChange: onFocusChange, onValueChange: function (v) { return onStyleChange("alignable", v); } })),
        renderButton(Models_1.InlineType.Link),
        react_1.default.createElement(ListItemMenu_1.ListItemMenu, { filteredButtonConfigs: filteredButtonConfigs, onToolbarEvent: onToolbarEvent, onFocusChange: onFocusChange }),
        renderButton(EditorTypes_1.MarkType.Comment),
        hasWidgetOverrides && (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: react_1.default.createElement(icons_1.ThumbsUp, null), onClick: function () { return alert("Style propagation menu: to be implemented"); } }))));
};
function calcSelectedTextElements(elements) {
    var e_2, _a;
    var types = new Set();
    try {
        for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
            var element = elements_1_1.value;
            if (element.type !== "listItem") {
                types.add(blockTypeMap[element.type] || commonTypes_1.TextElementType.P);
            }
            else {
                if (element.data.listType === "bullet") {
                    types.add(commonTypes_1.TextElementType.UnorderedListItem);
                }
                else {
                    types.add(commonTypes_1.TextElementType.OrderedListItem);
                }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (elements_1_1 && !elements_1_1.done && (_a = elements_1.return)) _a.call(elements_1);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return Array.from(types);
}
var blockTypeMap = {
    heading1: commonTypes_1.TextElementType.H1,
    heading2: commonTypes_1.TextElementType.H2,
    paragraph: commonTypes_1.TextElementType.P,
    blockQuote: commonTypes_1.TextElementType.Blockquote,
};
var TopLevelButton = function (_a) {
    var buttonConfig = _a.buttonConfig, onToolbarEvent = _a.onToolbarEvent, isSelected = _a.isSelected;
    return (react_1.default.createElement(kaleidoscope_1.ToolbarButton, { icon: buttonConfig.content, onClick: function (mouseEvent) {
            if (!(0, EventUtils_1.isPrimaryButton)(mouseEvent)) {
                return;
            }
            var eventData = __assign({ button: buttonConfig.type }, buttonConfig.data);
            onToolbarEvent(eventData);
        }, selected: isSelected }));
};
function getAvailableContextualControls(selectedElementTypes, filteredButtonConfigs) {
    var contextualStyleButton = filteredButtonConfigs.find(function (_a) {
        var type = _a.type;
        return type === EditorTypes_1.MarkType.Style;
    });
    if (!contextualStyleButton) {
        return {
            showAlignment: false,
            showBarColor: false,
            showDisplayQuoteIcon: false,
            showMarkerColor: false,
            showMarkerType: false,
            showTextColor: false,
            showTextSize: false,
            showTitle: false,
        };
    }
    return (0, GetControls_1.default)(selectedElementTypes, selectedElementTypes.includes(commonTypes_1.TextElementType.OrderedListItem));
}
function getStyleableValues(styleableType, styleables) {
    var e_3, _a;
    var valuesInSelection = new Set();
    try {
        for (var styleables_1 = __values(styleables), styleables_1_1 = styleables_1.next(); !styleables_1_1.done; styleables_1_1 = styleables_1.next()) {
            var s = styleables_1_1.value;
            var property = s.styleableConfig.properties.find(function (p) { return p.type === styleableType; });
            if (!property) {
                return { isAllowed: false, valuesInSelection: new Set() };
            }
            valuesInSelection.add((0, get_1.default)(s.style, property.path));
        }
    }
    catch (e_3_1) { e_3 = { error: e_3_1 }; }
    finally {
        try {
            if (styleables_1_1 && !styleables_1_1.done && (_a = styleables_1.return)) _a.call(styleables_1);
        }
        finally { if (e_3) throw e_3.error; }
    }
    return { isAllowed: true, valuesInSelection: valuesInSelection };
}
